module.exports = "/_next/static/images/f4f81f6e99cf3fc7742d946a982bb763-paperwork@desktop1366.jpg.webp";